import {
  CREATE_ROLE_URL,
  DELETE_ROLE,
  LIST_ROLE,
  ROLE_DROPDOWN,
  ROLE_INFO,
} from "../api";
import axiosInstance from "../axiosInstance";

export const createRole = (props) => (onResponse) => {
  try {
    axiosInstance
      .post(CREATE_ROLE_URL, props)
      .then((response) => {
        onResponse(response.data);
      })
      .catch((err) => {
        console.log(err);
        onResponse(err.response?.data);
      });
  } catch (error) {}
};

export const deleteRoleDetails = (id) => (onResponse) => {
  try {
    axiosInstance
      .delete(DELETE_ROLE, { data: id })

      .then((response) => {
        onResponse(response.data);
      })
      .catch((err) => {
        onResponse(err.response?.data);
      });
  } catch (error) {}
};

export const getRoleInfo = (props) => (onResponse) => {
  try {
    axiosInstance
      .get(ROLE_INFO + "?role=" + props.id)
      .then((response) => {
        onResponse(response.data);
      })
      .catch((err) => {
        onResponse(err.response?.data);
      });
  } catch (error) {}
};

export const listRole = (props) => (onResponse) => {
  try {
    let BASE_URL = `${LIST_ROLE}?page=${props?.page ?? ""}&limit=${
      props?.limit ?? ""
    }&search=${props?.search ?? ""}&sort_by=${props?.sort_by ?? ""}&order=${
      props?.order ?? ""
    }&museum_id=${props?.museum_id ?? ""}`;
    axiosInstance
      .get(BASE_URL)
      .then((response) => {
        onResponse(response.data);
      })
      .catch((err) => {
        console.log(err);
        onResponse(err.response?.data);
      });
  } catch (error) {}
};
export const listRoleDropdown = (props) => (onResponse) => {
  try {
    let BASE_URL = ROLE_DROPDOWN + "?";
    if (props.page) {
      BASE_URL += "page=" + props.page + "&";
    }
    if (props.limit) {
      BASE_URL += "limit=" + props.limit + "&";
    }
    if (props.search) {
      BASE_URL += "search=" + props.search + "&";
    }
    if (props.museum_id) {
      BASE_URL += "museum_id=" + props.museum_id + "&";
    }
    axiosInstance
      .get(BASE_URL)
      .then((response) => {
        // console.log(response)
        onResponse(response.data);
      })
      .catch((err) => {
        console.log(err);
        onResponse(err.response?.data);
      });
  } catch (error) {}
};
